import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/_services/data.service';

@Component({
  selector: 'app-flat-prototypes-filter',
  templateUrl: './flat-prototypes-filter.component.html',
  styleUrls: ['./flat-prototypes-filter.component.scss']
})
export class FlatPrototypesFilterComponent implements OnInit {

  @Input() public building;
  @Output() public currentPrototype = new EventEmitter();

  browserLang: string;
  currentProto: string = '';
  constructor(private translate: TranslateService, public dataService: DataService) { }

  ngOnInit(): void {
    this.browserLang = this.translate.getBrowserLang();
    this.dataService.curBuilding.subscribe(item => {
      this.building = item;
    })
  }

  wichPrototype(proto, event) {
    this.currentProto = proto;
    this.currentPrototype.emit(proto);
  }

}
